import React from "react";
import { useSignupVM } from "../viewmodels/SignupVM";
import SignupView from "../views/SignupView";

const SignupPage: React.FC = () => {
    const vm = useSignupVM();

    return <div>
        <SignupView
            form={vm.form}
            errorMessages={vm.errorMessages}
            onValueChange={vm.setField}
            submit={vm.submit}
            loading={vm.loading}
            showConfirm={vm.showConfirm}
            setShowConfirm={vm.setShowConfirm}
        />
    </div>;
};

export default SignupPage;